import './App.css';
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import TitleBar from './components/utils/titlebar';
import Navigation from './components/navigation/navigation';
import Footer from './components/utils/Footer';
import Home from './components/Home/home';
import PhotosPage from './components/photos/photosPage';
import AircraftsPage from './components/aircraft/aircraftsPage';
import ChartsPage from './components/charts/chartsPage';
import SourcesPage from './components/source/sourcesPage';
import GroupsPage from './components/groups/groupsPage';
import BasesPage from './components/bases/basesPage';
import TargetsPage from './components/targets/targetsPage';
import MissionsPage from './components/missions/missionsPage';
import SingleChartContent from './components/charts/singleChartContent';
import SingleAircraftContent from './components/aircraft/singleAircraftContent';
import SinglePhotoContent from './components/photos/singlePhotoContent';
import SingleBaseContent from './components/bases/singleBaseContent';
import SingleTargetsContent from './components/targets/singleTargetContent';
import SingleMissionsContent from './components/missions/singleMissionsContent';
import SingleGroupContent from './components/groups/singleGroupContent';
import SearchPage from './components/utils/search/searchPage';
import A404Page from './components/a404/a404page';

function App() {
  return (
    <BrowserRouter>
      <div className="app-header-stack">
        <TitleBar />
        <Navigation />
      </div>
      <div className="app-content">
        <Switch>
          <Route path="/photos/:id" component={SinglePhotoContent} />
          <Route path="/photos" component={PhotosPage} />
          <Route path="/aircraft/:id" component={SingleAircraftContent} />
          <Route path="/aircraft" component={AircraftsPage} />
          <Route path="/charts/:id" component={SingleChartContent} />
          <Route path="/charts" component={ChartsPage} />
          <Route path="/sources" component={SourcesPage} />
          <Route path="/groups/:id" component={SingleGroupContent} />
          <Route path="/groups" component={GroupsPage} />
          <Route path="/bases/:id" component={SingleBaseContent} />
          <Route path="/bases" component={BasesPage} />
          <Route path="/targets/:id" component={SingleTargetsContent} />
          <Route path="/targets" component={TargetsPage} />
          <Route path="/missions/:id" component={SingleMissionsContent} />
          <Route path="/missions" component={MissionsPage} />
          <Route path="/search" component={SearchPage} />
          <Route path="/" component={Home} exact />
          <Route path="*" component={A404Page} />
        </Switch>
      </div>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
